// AI-ASSISTED: generated with claude-code on 2026-06-03, reviewed by Yoann Hertienne
import { Component, ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type Props = {
  tool: string;
  children: ReactNode;
  lastRefreshedMinutesAgo?: number;
};

type State = { hasError: boolean };

export class TileBoundary extends Component<Props, State> {
  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  state: State = { hasError: false };

  componentDidCatch(error: Error) {
    // eslint-disable-next-line no-console
    console.error(`[TileBoundary:${this.props.tool}]`, error);
  }

  render() {
    if (this.state.hasError) {
      const { tool, lastRefreshedMinutesAgo } = this.props;
      const refreshed =
        typeof lastRefreshedMinutesAgo === 'number'
          ? `, last refreshed ${lastRefreshedMinutesAgo} min ago`
          : '';
      return (
        <Box
          role="alert"
          aria-label={`${tool} unavailable`}
          sx={{
            p: 2,
            border: 1,
            borderColor: 'warning.main',
            borderRadius: 1,
            bgcolor: 'warning.light',
          }}
        >
          <Typography variant="body2">
            {tool} unavailable{refreshed}.
          </Typography>
        </Box>
      );
    }
    return <>{this.props.children}</>;
  }
}
